/**
 * Serialize a Yjs update to a string from a Uint8Array.
 */
export function serializeYUpdate(update: Uint8Array): string {
    return JSON.stringify(Array.from(update));
}

/**
 * Deserialize a Yjs update from a string to a Uint8Array.
 */
export function deserializeYUpdate(serialized: string): Uint8Array {
    return new Uint8Array(JSON.parse(serialized));
}
